import User from "../types/user";

export enum UserRoles {
  GlobalAdmin = 1,
  DetectorAdmin,
  DetectorUser,
  GmdAdmin,
  GmdUser,
  ResponderAdmin,
  ResponderUser,
  InvestigatorAdmin,
  InvestigatorAudit,
  InvestigatorManager,
  InvestigatorSpecialist,
  InvestigatorOfficer,
  AnyAdmin,
  AnyGmd,
}

const checkRole = (user: User, role: UserRoles): boolean => {
  const adminRoles: UserRoles[] = [UserRoles.GlobalAdmin, UserRoles.GmdAdmin];

  const gmdRoles: UserRoles[] = [
    UserRoles.GlobalAdmin,
    UserRoles.GmdAdmin,
    UserRoles.GmdUser,
  ];

  if (!user || user.roles === undefined || user.roles.length < 1) return false;
  if (role === UserRoles.AnyAdmin)
    return !!user?.roles.some((x) => adminRoles.includes(x.id!));
  if (role === UserRoles.AnyGmd)
    return !!user?.roles.some((x) => gmdRoles.includes(x.id!));
  return !!user?.roles?.some((r) => r?.id === role);
};

export default checkRole;
